import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PrepaidcaseService } from "../shared/prepaidcase.service";

@Component({
  selector: 'app-prepaidcaselist',
  templateUrl: './prepaidcaselist.component.html',
  styleUrls: ['./prepaidcaselist.component.css']
})
export class PrepaidcaselistComponent implements OnInit {

  displayedColumns: string[] = ['CustomerName', 'LoanId', 'SavingsId', 'IsPrepaid', 'LoanBalance', 'SavingsBalance', 'New'];

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private prepaidcaseService: PrepaidcaseService,
    private router: Router) { }

  ngOnInit() {
    this.getInstallmentChangeList();
    this.dataSource.paginator = this.paginator;
  }

  public AddNew() {
    this.router.navigate(['/prepaidcase']);
  }

  getInstallmentChangeList() {

    this.prepaidcaseService.FetchPrepaidCaseList().subscribe(data => {
      this.dataSource.data = data;
    })
  }

  Edit(Savings: any) {
    this.router.navigate(['/prepaidcase', Savings.SavingsId]);
  }

  applyFilter(filterValue: string) {

    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
}
